<card name="Формы">
  <div card content>
    <div class="row">
      <div class=" col-30">
        <div class="form-group">
          <label for="simple">Input</label>
          <input type="text" class="form-control" id="simple" placeholder="Enter email">
        </div>
        <div class="form-group">
          <label for="filled">Input filled</label>
          <input type="text" class="form-control" id="filled" placeholder="Enter email" value="info@amaya.ru">
        </div>
        <div class="form-group">
          <label for="disabled">Input disabled</label>
          <input type="text" class="form-control" id="disabled" placeholder="Enter email" disabled>
        </div>
        <div class="form-group">
          <label for="number">Input with number input</label>
          <input type="number" class="form-control" id="number" placeholder="Enter number">
        </div>
      </div>
      <div class="col-30">
        <div class="form-group">
          <label for="left">Input with icon left</label>
          <input-icon placement="left">
            <icon-search class="text-muted" icon></icon-search>
            <input type="text" class="form-control" id="left" placeholder="Enter email">
          </input-icon>
        </div>
        <div class="form-group">
          <label for="right">Input with icon right</label>
          <input-icon placement="right">
            <input type="text" class="form-control" id="right" placeholder="Enter email">
            <icon-search class="text-muted" icon></icon-search>
          </input-icon>
        </div>
        <div class="form-group">
          <label for="success">Input success</label>
          <input type="text" class="form-control is-valid" id="success" placeholder="Enter email">
        </div>
        <div class="form-group">
          <label for="error">Input error</label>
          <input type="text" class="form-control is-invalid" id="error" placeholder="Enter email">
        </div>
      </div>
      <div class="col-30">
        <div class="form-group">
          <label for="select">Select simple</label>
          <ng-select id="select"
                     placeholder="Select"
                     bindLabel="name"
                     bindValue="id"
                     appendTo="body"
                     [items]="select"
                     [searchable]="true"
                     [hideSelected]="true"
                     [clearable]="false"
                     [(ngModel)]="singleSelected">
          </ng-select>
        </div>
        <div class="form-group">
          <label for="outer">Select multiple</label>
          <ng-select id="outer"
                     placeholder="Select"
                     bindLabel="name"
                     bindValue="id"
                     appendTo="body"
                     [items]="select"
                     [multiple]="true"
                     [searchable]="true"
                     [hideSelected]="true"
                     [clearable]="false"
                     [(ngModel)]="selectedOuter">
          </ng-select>
          <cloud-tags class="d-block mt-2"
                      bindLabel="name"
                      bindValue="id"
                      [items]="select"
                      [(selected)]="selectedOuter">
          </cloud-tags>
        </div>
        <div class="form-group">
          <label for="seldisabled">Select disabled</label>
          <ng-select id="seldisabled"
                     placeholder="Select"
                     bindLabel="name"
                     bindValue="id"
                     [items]="select"
                     [searchable]="false"
                     [hideSelected]="true"
                     [clearable]="false"
                     [disabled]="true"
                     [(ngModel)]="singleSelected">
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-40">
        <div class="form-group">
          <label for="lg">Input large</label>
          <input type="text" class="form-control form-control-lg" id="lg" placeholder=".form-control-lg">
        </div>
      </div>
      <div class="col-40">
        <div class="form-group">
          <label for="simpleSize">Input simple</label>
          <input type="text" class="form-control" id="simpleSize" placeholder=".form-control">
        </div>
      </div>
      <div class="col-40">
        <div class="form-group">
          <label for="sm">Input small</label>
          <input type="text" class="form-control form-control-sm" id="sm" placeholder=".form-control-sm">
        </div>
      </div>

      <div class="col-120">
        <div class="form-group">
          <label for="textarea">Textarea</label>
          <textarea name="" id="textarea" class="form-control" cols="30" rows="5" placeholder="Ваш комментарий"></textarea>
        </div>
      </div>
    </div>
  </div>
</card>
